export const enum FeatureFlagId {
  TEMPLATE_LIBRARY_CATEGORIES = 'template-library-categories',
}

interface FeatureFlagMeta {
  description: string;
}

export const featureFlagDefinitions: Record<FeatureFlagId, FeatureFlagMeta> = {
  [FeatureFlagId.TEMPLATE_LIBRARY_CATEGORIES]: {
    description: 'Template Library: Categories',
  },
};
